import { memo } from 'react';

import { AddUsers } from './addUsers/addUsers';
import { AddTeams } from './addTeams/addTeams';

import {
  Dialog,
  DialogHeader,
  DialogContent,
  DialogTitle
} from '@/shadcn/dialog';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/shadcn/tabs';
import { UserRoundPlus, UsersRound } from 'lucide-react';
import { TestId } from '@/types/testId';

enum Tab {
  AddTeams = 'AddTeams',
  AddUsers = 'AddUsers'
}

type Props = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  groupName: string;
  submitAddUsers: (usersEmails: string[]) => void;
  submitAddTeams: (teamsAccountIds: number[]) => void;
};

export const AddParticipantsModal = memo(
  ({
    isOpen,
    onOpenChange,
    groupName,
    submitAddUsers,
    submitAddTeams
  }: Props) => {
    return (
      <Dialog open={isOpen} onOpenChange={onOpenChange}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Add participants</DialogTitle>
          </DialogHeader>
          <Tabs defaultValue={Tab.AddTeams} className="w-full">
            <TabsList className="bg-background grid w-full grid-cols-2">
              <TabsTrigger
                value={Tab.AddTeams}
                data-testid={TestId.AddParticipantsModal.TeamsTab}
              >
                <UsersRound /> Add teams
              </TabsTrigger>
              <TabsTrigger
                value={Tab.AddUsers}
                data-testid={TestId.AddParticipantsModal.UsersTab}
              >
                <UserRoundPlus /> Add users
              </TabsTrigger>
            </TabsList>
            <TabsContent value={Tab.AddTeams}>
              <AddTeams groupName={groupName} submit={submitAddTeams} />
            </TabsContent>
            <TabsContent value={Tab.AddUsers}>
              <AddUsers submit={submitAddUsers} />
            </TabsContent>
          </Tabs>
        </DialogContent>
      </Dialog>
    );
  }
);
